import axios from "axios";
import baseURL from "../configs/api";

export const post_Refund = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}refund?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const refundForCancelReservation = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}refund/RefundForCancelReservation?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const getReservationRefundsByReservationId = (reservationId: number, tenantId: string) => {
    return getFetch(`refund/RefundsByReservation/${reservationId}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}